module.exports = __webpack_public_path__ + "img/Gordon Saksena.f9d082e7.jpg";